var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4341 8.00848C13.319 8.26919 13.0583 8.4351 12.7739 8.4351H10.6069V12.0478C10.6069 12.4474 10.2852 12.769 9.88569 12.769H4.10936C3.70982 12.769 3.38816 12.4474 3.38816 12.0478V8.4351H1.22119C0.82166 8.4351 0.5 8.11005 0.5 7.7139C0.5 7.53784 0.564332 7.36516 0.682838 7.23311L6.46255 0.732199C6.74697 0.434241 7.21761 0.420697 7.51556 0.705112C7.52572 0.71527 7.53249 0.722041 7.54265 0.732199L13.3224 7.23311C13.5052 7.44303 13.5526 7.74776 13.4341 8.00848Z",
    stroke: "#8C8C76",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.70898 14.6348H10.2844",
    stroke: "#8C8C76",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.70898 16.5H10.2844",
    stroke: "#8C8C76",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromote);
export default __webpack_public_path__ + "static/media/promote.f09699c46903bcdafef12085d876be96.svg";
export { ForwardRef as ReactComponent };